<template>
  <!-- Main Content Center Rail -->
  <v-container class="main-center-details" @keyup.esc="hideEntryForms">
    <!-- <v-container class="main-center-details"> -->
    <div v-if="customerOrChatSelected != null" class="d-flex flex-column pt-2">
      <div class="main-center-top  flex-shrink-0" v-if="currentCustomer">
        <v-btn-toggle mandatory dense borderless>
          <v-btn small v-on:click="filterList('')">
            All
          </v-btn>
          <v-btn small v-on:click="filterList('call')">
            Calls
          </v-btn>
          <v-btn small v-on:click="filterList('msg')">
            Messages
          </v-btn>
          <!-- <v-btn small v-on:click="filterList('chat')">
            Chats
          </v-btn> -->
          <v-btn small v-on:click="filterList('note')">
            Notes
          </v-btn>
          <!-- <v-btn small v-on:click="filterList('appt')">
            Appointments
          </v-btn> -->
          <!-- <v-btn small v-on:click="filterList('file')">
            Files
          </v-btn> -->
        </v-btn-toggle>
        <v-btn icon><v-icon>mdi-card-account-details-online</v-icon></v-btn>
      </div>

      <div class="main-center-middle flex-grow-1">
        <div
          class="msg-detail-container row"
          v-for="historyItem in historyList"
          :key="'history-list-' + historyItem.type + '-' + historyItem.id"
        >
          <v-lazy
            v-model="historyItem.isActive"
            :options="lazyOptions"
            v-if="historyItem.type == 'call'"
          >
            <call-content-bubble
              v-if="historyItem.type == 'call'"
              :historyItem="historyItem"
              :customerName="customerName"
            ></call-content-bubble>
          </v-lazy>

          <v-lazy
            v-model="historyItem.isActive"
            :options="lazyOptions"
            v-if="['msg', 'msgSch'].includes(historyItem.type)"
          >
            <message-content-bubble
              v-if="['msg', 'msgSch'].includes(historyItem.type)"
              :historyItem="historyItem"
              :customerName="customerName"
            ></message-content-bubble>
          </v-lazy>

          <v-lazy
            v-model="historyItem.isActive"
            :options="lazyOptions"
            v-if="historyItem.type == 'note'"
          >
            <note-content-bubble
              v-if="historyItem.type == 'note'"
              :historyItem="historyItem"
              :customerName="customerName"
              :showActionEntry="showActionEntry"
              :hoverCheck="hoverCheck"
            ></note-content-bubble>
          </v-lazy>

          <!-- <v-lazy
            v-model="historyItem.isActive"
            :options="lazyOptions"
            v-if="historyItem.type == 'chat' || historyItem.type == 'chatMsg'"
          >
            <chat-content-bubble
              v-if="historyItem.type == 'chat' || historyItem.type == 'chatMsg'"
              :historyItem="historyItem"
              :customerName="customerName"
              :newChat="newChat"
              :showActionEntry="showActionEntry"
              :endChat="endChat"
            ></chat-content-bubble>
          </v-lazy> -->

          <!-- <v-lazy
            v-model="historyItem.isActive"
            :options="lazyOptions"
            v-if="historyItem.type == 'appt'"
          >
            <appointment-content-bubble
              v-if="historyItem.type == 'appt'"
              :historyItem="historyItem"
              :customerName="customerName"
              :showActionEntry="showActionEntry"
              :hoverCheck="hoverCheck"
            ></appointment-content-bubble>
          </v-lazy> -->
        </div>

        <div v-if="historyList.length == 0" class="no-interactions">
          <div v-if="listFilter == ''">
            This is the start of your history with this customer. Add your first
            interaction.
          </div>
          <div v-if="listFilter == 'call'">
            There are no calls from this customer.
          </div>
          <div v-if="listFilter == 'msg'">
            You haven't sent a message to this customer yet. Send your first
            now.
          </div>
          <div v-if="listFilter == 'note'">
            You haven't added a note to this customer yet. Add your first now.
          </div>
          <div v-if="listFilter == 'email'">
            You haven't sent an email to this customer yet. Send your first now.
          </div>
          <div v-if="listFilter == 'appt'">
            You haven't created an appointment for this customer yet. Add your
            first now.
          </div>
          <div v-if="listFilter == 'chat'">
            This customer hasn't chatted with you yet.
          </div>
        </div>

        <div id="end_of_history"></div>
      </div>

      <div class="flex-shrink-0">
        <div
          class="history-actions mt-4"
          v-if="!(newNote || newMessage || newEmail)"
        >
          <v-btn
            small
            tile
            outlined
            color="primary"
            class="mx-2 mb-4"
            v-if="currentCustomer && $vuetify.breakpoint.smAndDown"
            @click="switchToCustomerHistory"
            ><v-icon left>mdi-card-account-details</v-icon> Contact</v-btn
          >
          <v-btn
            small
            tile
            outlined
            color="primary"
            class="mx-2 mb-4"
            v-if="currentCustomer"
            @click="showActionEntry({ type: 'note' })"
            ><v-icon left>mdi-pencil</v-icon> Note</v-btn
          >
          <v-btn
            small
            tile
            outlined
            color="primary"
            class="mx-2 mb-4"
            v-if="currentCustomer"
            @click="showActionEntry({ type: 'msg' })"
            ><v-icon left>mdi-message-outline</v-icon> Message</v-btn
          >
          <!-- <v-btn
            small
            tile
            outlined
            color="primary"
            class="mx-2"
            v-if="currentCustomer"
            @click="showActionEntry({ type: 'email' })"
            ><v-icon left>mdi-email-outline</v-icon> Email</v-btn
          > -->
        </div>
      </div>

      <message-form
        v-if="newMessage"
        ref="message-form"
        :messageText="newMessageText"
        :messageScheduledId="messageScheduledIdToEdit"
        :oldScheduledDate="messageScheduledDateToEdit"
      ></message-form>
      <!-- <email-form
        v-if="newEmail"
        ref="email-form"
        :newMessageText="newEmailText"
      ></email-form> -->
      <note-form
        v-if="newNote"
        ref="note-form"
        :noteId="noteIdToEdit"
      ></note-form>
      <!-- <chat-form v-if="newChat" ref="chat-form" :chatId="newChatId"></chat-form> -->
    </div>

  </v-container>
</template>

<script>
//import Vuetify from 'vuetify';
import { format } from "date-fns";
const MessageForm = () =>
  import(
    /* webpackChunkName: "components-customers-modals-MessageForm" */ `./modals/MessageForm.vue`
  );
// const EmailForm = () =>
//   import(
//     /* webpackChunkName: "components-customers-modals-EmailForm" */ `./modals/EmailForm.vue`
//   );
const NoteForm = () =>
  import(
    /* webpackChunkName: "components-customers-modals-NoteForm" */ `./modals/NoteForm.vue`
  );
// const ChatForm = () =>
//   import(
//     /* webpackChunkName: "components-customers-modals-ChatForm" */ `./modals/ChatForm.vue`
//   );
// const MessageContentBubble = () =>
//   import(
//     /* webpackChunkName: "components-customers-history-MessageContentBubble" */ `./history/MessageContentBubble.vue`
//   );
import CallContentBubble from "./history/CallContentBubble.vue";
import MessageContentBubble from "./history/MessageContentBubble.vue";
// const ChatContentBubble = () =>
//   import(
//     /* webpackChunkName: "components-customers-history-ChatContentBubble" */ `./history/ChatContentBubble.vue`
//   );
// import ChatContentBubble from "./history/ChatContentBubble.vue";
// const NoteContentBubble = () =>
//   import(
//     /* webpackChunkName: "components-customers-history-NoteContentBubble" */ `./history/NoteContentBubble.vue`
//   );
import NoteContentBubble from "./history/NoteContentBubble.vue";
// const AppointmentContentBubble = () =>
//   import(
//     /* webpackChunkName: "components-customers-history-AppointmentContentBubble" */ `./history/AppointmentContentBubble.vue`
//   );
// import AppointmentContentBubble from "./history/AppointmentContentBubble.vue";
import { customerModalMixins } from "../../mixins/customerModals";

export default {
  name: "HistoryCenterRail",
  components: {
    MessageForm,
    // EmailForm,
    NoteForm,
    // ChatForm,
    CallContentBubble,
    MessageContentBubble,
    // ChatContentBubble,
    NoteContentBubble
    // AppointmentContentBubble
  },
  mixins: [customerModalMixins],
  props: {
    msg: String
  },
  data: function() {
    return {
      fab: false,
      listFilter: "",
      newMessage: false,
      newMessageText: "",
      messageScheduledIdToEdit: null,
      messageScheduledDateToEdit: null,
      newEmail: false,
      newEmailText: "",
      newNote: false,
      noteIdToEdit: 0,
      newChat: false,
      newChatId: 0,
      hoverCheck: {},
      AccountId: 0,
      CustomerId: 0,
      lazyIsActive: false,
      lazyOptions: { threshold: 0.5 },
      lazyMinHeight: 200,
      lazyTransition: "fade-transition"
    };
  },
  computed: {
    showCustomerDetail() {
      return this.$store.getters["entities/settings/query"]().first()
        .showCustomerDetail;
    },
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    account() {
      return this.$store.getters["entities/accounts"]().first();
    },
    currentCustomer() {
      let vueThis = this;
      if (this.user && this.user.currentCustomerId) {
        vueThis.AccountId = this.user.accountId;
        vueThis.CustomerId = this.user.currentCustomerId;
        return vueThis.$store.getters["entities/customers/query"]()
          .withAllRecursive(2)
          .find(vueThis.user.currentCustomerId);
      } else {
        return null;
      }
    },
    customerName() {
      return this.currentCustomer
        ? this.currentCustomer.longName
        : this.customerOrChatSelected == "chat"
        ? "Online chat"
        : this.customerOrChatSelected == "call"
        ? "Unknown caller"
        : "Unknown";
    },
    selectedChatId() {
      let selectedChatId = null;
      if (this.$parent.$parent.$parent.selectedChatId) {
        selectedChatId = this.$parent.$parent.$parent.selectedChatId;
      }
      return selectedChatId;
    },
    currentSelectedChat() {
      if (this.selectedChatId) {
        return this.$store.getters["entities/chats/query"]()
          .withAllRecursive(1)
          .find(this.selectedChatId);
      } else {
        return null;
      }
    },
    selectedCallNumber() {
      let selectedCallNumber = null;
      if (this.$parent.$parent.$parent.selectedCallNumber) {
        selectedCallNumber = this.$parent.$parent.$parent.selectedCallNumber;
      }
      return selectedCallNumber;
    },
    currentSelectedCall() {
      if (this.selectedCallNumber) {
        const selectedCallNumber = this.selectedCallNumber;
        let calls = this.$store.getters["entities/calls/query"]()
          .withAllRecursive(1)
          .get();
        // .find(this.selectedCallNumber);
        return calls.filter(call => {
          if (
            call.toPhone == selectedCallNumber ||
            call.fromPhone == selectedCallNumber
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else {
        return null;
      }
    },
    customerOrChatSelected() {
      if (this.currentSelectedChat != null) {
        return "chat";
      } else if (this.currentSelectedCall != null) {
        return "call";
      } else if (this.currentCustomer != null) {
        return "customer";
      }
      return null;
    },
    historyList() {
      let calls = this.currentCustomer ? this.currentCustomer.calls : [];
      calls.forEach(function(value) {
        value.type = "call";
      });
      let messages = this.currentCustomer ? this.currentCustomer.messages : [];
      messages.forEach(function(value) {
        value.type = "msg";
      });
      let messagesScheduled = this.currentCustomer
        ? this.currentCustomer.messagesScheduled
        : [];
      messagesScheduled.forEach(function(value) {
        value.type = "msgSch";
      });

      let notes = this.currentCustomer ? this.currentCustomer.notes : [];
      notes.forEach(function(value) {
        value.type = "note";
      });
      let appointments = this.currentCustomer
        ? this.currentCustomer.appointments
        : [];
      appointments.forEach(function(value) {
        value.type = "appt";
      });

      let chats = this.currentCustomer ? this.currentCustomer.chats : [];
      let chatMessages = [];

      // For Chats without Customer yet
      if (this.currentCustomer == null && this.currentSelectedChat != null) {
        chats.push(this.currentSelectedChat);
      }
      chats.forEach(function(chat) {
        chat.type = "chat";
        chatMessages.push(...chat.chatMessages);
        chatMessages.forEach(function(msg) {
          msg.type = "chatMsg";
        });
        if (chatMessages && chatMessages.length > 0) {
          chatMessages[chatMessages.length - 1].isLast = true;
        }
      });

      // for calls without customer yet
      if (this.currentCustomer == null && this.currentSelectedCall != null) {
        calls = this.currentSelectedCall;
        calls.forEach(function(call) {
          call.type = "call";
        });
      }

      // build history list
      let historyList = [];
      if (this.listFilter == "call") {
        historyList.push(...calls);
      } else if (this.listFilter == "msg") {
        historyList.push(...messages, ...messagesScheduled);
      } else if (this.listFilter == "chat") {
        historyList.push(...[...chats, ...chatMessages]);
      } else if (this.listFilter == "note") {
        historyList.push(...notes);
      } else if (this.listFilter == "appt") {
        historyList.push(...appointments);
      } else {
        historyList.push(
          ...[
            ...messages,
            ...messagesScheduled,
            ...notes,
            // ...appointments,
            ...chats,
            ...chatMessages,
            ...calls
          ]
        );
      }
      return historyList.sort((a, b) => {
        let aDate = a.updatedAt;
        let bDate = b.updatedAt;
        if (a.type == "msg" || a.type == "chat" || a.type == "chatMsg") {
          aDate = a.createdAt;
        }
        if (b.type == "msg" || b.type == "chat" || b.type == "chatMsg") {
          bDate = b.createdAt;
        }
        if (a.type == "msgSch") {
          aDate = a.scheduledAt;
        }
        if (b.type == "msgSch") {
          bDate = b.scheduledAt;
        }
        if (a.type == "call") {
          aDate = a.startTime;
        }
        if (b.type == "call") {
          bDate = b.startTime;
        }
        return aDate - bDate;
      });
    },
    historyListEmpty() {
      return this.historyList.length == 0;
    }
  },
  created() {
    let customerData = this.currentCustomer;
    if (customerData) {
      customerData.isRead = true;
      customerData.isDirty = true;
      this.$store.dispatch("entities/customers/updateCustomer", {
        where: this.currentCustomer.id,
        data: customerData
      });
    }
  },
  mounted() {
    this.scrollToBottomOfHistory();
  },
  watch: {
    historyList: function(after, before) {
      // check for historyList change to
      let beforeDate = 0;
      if (before && before.length && before.length > 0) {
        const lastBefore = before[before.length - 1];
        beforeDate = lastBefore.scheduledAt
          ? lastBefore.scheduledAt
          : lastBefore.updatedAt
          ? lastBefore.updatedAt
          : lastBefore.createdAt
          ? lastBefore.createdAt
          : lastBefore.date
          ? lastBefore.date
          : 0;
      }
      let afterDate = 0;
      if (after && after.length && after.length > 0) {
        const lastAfter = after[after.length - 1];
        afterDate = lastAfter.scheduledAt
          ? lastAfter.scheduledAt
          : lastAfter.updatedAt
          ? lastAfter.updatedAt
          : lastAfter.createdAt
          ? lastAfter.createdAt
          : lastAfter.date
          ? lastAfter.date
          : 0;
      }
      if (beforeDate != afterDate || 1 == 1) {
        this.scrollToBottomOfHistory();
      }
    }
  },
  methods: {
    switchToCustomerHistory() {
      this.$store.dispatch("entities/settings/update", {
        where: 1,
        data: {
          showCustomerDetail: true
        }
      });
    },
    userNameFromHistoryItem(historyItem) {
      return historyItem.user ? historyItem.user.longName : "";
    },
    formattedDateTime(number) {
      return format(new Date(number), "E h:mm a, M/d/y");
    },
    filterList(type) {
      this.listFilter = type;
      this.scrollToBottomOfHistory();
    },
    showActionEntry(args) {
      let vueThis = this;
      this.hideEntryForms();
      this.$nextTick(async function() {
        if (args.type == "chat") {
          this.newChatId = args.chatId;
          this.newChat = true;
          vueThis.scrollToBottomOfHistory();
        } else if (args.type === "msg") {
          if (this.checkMobileContactInfoExists()) {
            this.newMessageText = "";
            this.messageScheduledIdToEdit = null;
            this.messageScheduledDateToEdit = null;
            vueThis.newMessage = true;
            vueThis.scrollToBottomOfHistory();
          } else {
            const contactInfoMsg =
              "Please add a mobile contact that is accepting notifications first.";
            alert(contactInfoMsg);
            let vueThis = this;
            this.$root.$children[0].showCustomerEditorModals = true;
            // eslint-disable-next-line no-unused-vars
            let timer = setTimeout(function checkCustomerEditorModals() {
              if (
                vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
                undefined
              ) {
                let theContainer =
                  vueThis.$root.$children[0].$refs["customer-editor-modals"];
                theContainer.ContactInfoModalId = -1;
                theContainer.ContactInfoMessage = contactInfoMsg;
                theContainer.CustomerId = vueThis.currentCustomer.id;
                theContainer.showContactInfoFormModal = true;
                timer = null;
              }
            }, 100);
          }
        } else if (args.type === "email") {
          if (this.checkEmailContactInfoExists()) {
            this.newMessageText = "";
            vueThis.newEmail = true;
            vueThis.scrollToBottomOfHistory();
          } else {
            const contactInfoMsg =
              "Please add an email contact accepting notifications before messaging.";
            let vueThis = this;
            this.$root.$children[0].showCustomerEditorModals = true;
            // eslint-disable-next-line no-unused-vars
            let timer = setTimeout(function checkCustomerEditorModals() {
              if (
                vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
                undefined
              ) {
                let theContainer =
                  vueThis.$root.$children[0].$refs["customer-editor-modals"];
                theContainer.ContactInfoModalId = -1;
                theContainer.ContactInfoMessage = contactInfoMsg;
                theContainer.CustomerId = vueThis.currentCustomer.id;
                theContainer.showContactInfoFormModal = true;
                timer = null;
              }
            }, 100);
          }
        } else if (args.type === "note") {
          this.noteIdToEdit = 0;
          this.newNote = true;
          if (args.record) {
            this.noteIdToEdit = args.record.id;
          }
        } else if (args.type === "appt") {
          args.id = args.record.id;
          this.openAppointmentModal(this, args);
        }
      });
    },
    checkMobileContactInfoExists() {
      const contacts = this.currentCustomer.contactInfos;
      const messageableContacts = contacts.filter(
        contact =>
          contact.label === "mobile" && contact.receiveNotification === true
      );
      if (messageableContacts.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    checkEmailContactInfoExists() {
      const contacts = this.currentCustomer.contactInfos;
      const messageableContacts = contacts.filter(
        contact => contact.type === "email"
      );
      if (messageableContacts.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    trim(message) {
      return message.trim();
    },
    hideEntryForms() {
      this.newMessage = false;
      this.newEmail = false;
      this.newNote = false;
      this.newChat = false;
      this.newChatId = 0;
      this.isReviewRequest = false;
      this.noteIdToEdit = 0;
    },
    scrollToBottomOfHistory() {
      let vueThis = this;
      this.$nextTick(function() {
        if (vueThis.customerOrChatSelected) {
          vueThis.$vuetify.goTo("#end_of_history", {
            duration: 0,
            offset: 0,
            container: ".main-center-middle",
            easing: "easeInOutCubic"
          });
        }
      });
    },
    async endChat(chatLookup) {
      if (!chatLookup.customerId) {
        this.$root.$children[0].$refs["router-view"].selectedChatId = null;
      }
      await this.$store.dispatch("entities/chatLookups/clickChatLookup", {
        chatLookup: chatLookup,
        action: "endChat"
      });
    }
  }
};
</script>

<style scoped lang="stylus">
.no-interactions {
  padding: 0rem 1rem;
}
</style>
